import { styled } from "@mui/system";
import { Grid } from "@mui/material";

const StyledGridItem = styled(Grid)({
  padding: "8px",
});

export default StyledGridItem;
